<div *ngIf="!loading && selectedVariables && !graphErrorMessage && !neutralMessage">

  <!--
    #28 — the container height is bound, not fixed: a legend that wraps onto extra rows
    grows the chart rather than overlapping the date axis or being paged away. The
    component keeps this binding and the ECharts canvas height in step; the initial value
    is the previous 400px baseline, so a one-row legend is unchanged. `mb-3` separates the
    bottom-anchored legend from the download controls below — the gap lives outside the
    canvas, so legend packing, chart height and PNG output are untouched.
  -->
  <div *ngIf="echartsOptions && Object.keys(echartsOptions).length>0" class="mb-3" echarts [options]="echartsOptions" [extentions]="echartsExtensions" [style.height.px]="timeSeriesChartHeightPx" (chartInit)="onChartInit($event)"></div>

  <!-- Multiple Profile Charts -->
  <div *ngIf="profileCharts">
    <div *ngFor="let chart of profileCharts" echarts [options]="chart" [extentions]="echartsExtensions"></div>
  </div>

  <div *ngIf="emptyResults">
    <div *ngFor="let item of emptyResults" class="text-center text-danger fw-bold mb-5" [class.mt-5]="graphType!=='profile'">No Results for {{ formatColumnDisplay(item.column) }} in station {{ item.station }}</div>
  </div>

  <div class="flex justify-content-end gap-2" *ngIf="selectedVariables && selectedVariables.length>0">
    <button mat-raised-button color="primary" (click)="onDownloadPng()" *ngIf="echartsInstance">
      <mat-icon>image</mat-icon>
      Download PNG
    </button>
    <button mat-raised-button color="accent" (click)="onDownload()">
      <mat-icon>download</mat-icon>
      Download CSV
    </button>
  </div>
</div>

<!--
  #29 — Dataset Charts neutral state. Deliberately NOT styled as an error: an incomplete
  selection is normal UI state. Mutually exclusive with the chart block above, the error
  block below and the spinner, so it can never be shown alongside them.
-->
<div *ngIf="neutralMessage && !loading && !graphErrorMessage" class="text-center mt-5 mb-5">{{ neutralMessage }}</div>

<div *ngIf="graphErrorMessage" class="fw-bold text-center mt-5 mb-5 text-danger" [innerHTML]="graphErrorMessage"></div>

<div class="flex justify-content-center" *ngIf="loading">
  <mat-progress-spinner class="example-margin" color="accent" mode="indeterminate"></mat-progress-spinner>
</div>
